import {
  CheckboxInput,
  CheckboxGroup,
  DatePicker,
} from 'components/common';
import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { genderOptions, USER_GOAL } from './constants';
import PropTypes from 'prop-types';
import { SelectField } from 'components/formFields';
import { connectInput } from 'lib/form';
import datetime from 'lib/datetime';

const DatePickerField = connectInput(DatePicker, {
  onChangeArgType: 'raw-value',
});

const KycDetails = ({ values, setValue }) => {
  return (
    <>
      <Row>
        <Col lg={6}>
          <SelectField
            name="gender"
            label="I am a"
            options={genderOptions}
          />
        </Col>

        <Col lg={6}>
          <DatePickerField
            name="birthday"
            label="My Birthday is on"
            placeHolder="YYYY-MM-DD"
            outputFormat={(output) =>
              datetime(output).format('YYYY-MM-DD')
            }
            toMonth={new Date()}
            disabledDays={(day) => datetime(day).isAfter(datetime())}
          />
        </Col>
      </Row>

      <Row>
        <Col>
          <CheckboxGroup
            name="goal"
            label="I want to"
            value={values?.goals || []}
            onChange={(value) => {
              setValue('goals', value);
            }}
          >
            {Object.values(USER_GOAL).map((goal) => (
              <CheckboxInput key={goal} label={goal} value={goal} />
            ))}
          </CheckboxGroup>
        </Col>
      </Row>
    </>
  );
};

KycDetails.propTypes = {
  values: PropTypes.objectOf({
    goal: PropTypes.string,
    birthday: PropTypes.string,
    gender: PropTypes.string,
  }),
  setValue: PropTypes.func,
};

KycDetails.defaultProps = {
  setValue: () => {},
};

export default KycDetails;
